import React from 'react';
import {
	PromptHeader,
	ToggleIA,
	RulesTimeAction,
	PromptCustomization
} from './components';
import { getTenantId } from 'util/isAdmin';
import { useStatusIA, useSettings } from './hooks/settings';
import { useMessage } from 'newComponents/ChatWhatsapp/context/MessageContext';
export default function Prompts() {
	const tenantId = getTenantId();
	const { statusIA, isLoading: isLoadingStatus, refetch, shouldFinalizeChat, getChatsWithoutResponse, shouldSendMessageAfterCall } = useStatusIA( `session-${tenantId}` );
	const { settings, isLoading: isLoadingSettings } = useSettings( `session-${tenantId}` );
	const { users } = useMessage();

	return (
		<div className='d-flex flex-column' style={{ gap: '22px' }}>
			<PromptHeader />
			<ToggleIA
				statusIA={statusIA}
				users={users}
				isLoadingStatus={isLoadingStatus}
				refetch={refetch}
				settings={settings}
				isLoadingSettings={isLoadingSettings}
				shouldFinalizeChat={shouldFinalizeChat}
				getChatsWithoutResponse={getChatsWithoutResponse}
				shouldSendMessageAfterCall={shouldSendMessageAfterCall}
			/>
			{statusIA && (
				<>
					<PromptCustomization />
				</>
			)}
			<RulesTimeAction users={users} settings={settings} isLoadingSettings={isLoadingSettings} />
		</div>
	);
}
